var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aeg-case-home',{attrs:{"caseViews":_vm.caseViews,"addProposalButtonText":"Add Public Liability Proposal","productTypeLabel":"Liability Type","selectProductInsuranceType":"public_liability"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }